import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";


export default class Infobox {
  constructor() {
    this.infoBoxes = document.querySelectorAll('.infobox');
    if (this.infoBoxes.length === 0) return;

    gsap.registerPlugin(ScrollTrigger);
    this.init();
  }

  init() {
    this.infoBoxTimelines = Object.create({});

    this.infoBoxes.forEach(box => {
      let circumference = 2 * (box.offsetHeight + box.offsetWidth);

      box.style = `--stroke-dasharray: ${circumference}px; --stroke-dashoffset: -${circumference / 3.75}px`;

      ScrollTrigger.create({
        trigger: box,
        start: 'top 75%',
        onEnter: () => {
          box.classList.add('infobox--animate');
        }
      });
    });
  }
}
